import * as React from "react";
import {useMemo} from "react";
import {observer} from "mobx-react-lite";
import {ActionIcon, getTreeExpandedState, Group, Text, Tree, TreeNodeData, useTree} from "@mantine/core";
import {IconChevronRight} from "@tabler/icons-react";

import {AtlasStructureViewModel} from "../../../../viewmodel/atlasStructureViewModel";
import {AtlasViewModel} from "../../../../viewmodel/atlasViewModel";
import {isSelectedIcon} from "../NeuronTable";

interface StructureTreeNodeData extends TreeNodeData {
    structure: AtlasStructureViewModel;
}

function generateTree(root: AtlasStructureViewModel): StructureTreeNodeData {
    const children = root.children.map(c => generateTree(c));

    return {
        label: root.structure.name,
        value: root.structure.id,
        structure: root,
        children: children
    }
}

export const StructureTree = observer(({atlas}: {atlas: AtlasViewModel}) => {
    const data = useMemo(() => atlas.rootStructure ? [generateTree(atlas.rootStructure)] : [], [atlas]);

    const onClick =(evt: any, n: StructureTreeNodeData) => {
        evt.stopPropagation();
        atlas.toggle(n.structure.structure.id);
    }

    const tree = useTree({
        initialExpandedState: getTreeExpandedState(data, atlas.rootStructure ? [atlas.rootStructure.structure.id] : []),
    });

    if (!atlas.rootStructure) {
        return null;
    }

    return (
        <Tree tree={tree} data={data} levelOffset={23}
              renderNode={({node, expanded, hasChildren, elementProps}) => {
                  const n = node as StructureTreeNodeData;
                  return (
                      <Group gap={4} {...elementProps}>
                          {hasChildren && (
                              <IconChevronRight
                                  size={18}
                                  style={{transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)'}}
                              />
                          )}
                          <Group gap={0}>
                              <ActionIcon variant="transparent" onClick={(e) => onClick(e, n)}>
                                  {isSelectedIcon(n.structure.isDisplayed)}
                              </ActionIcon>
                              <Text size="sm" lineClamp={1} truncate="end" onClick={(e) => onClick(e, n)}>{n.structure.structure.name}</Text>
                          </Group>
                      </Group>
                  )
              }}
        />
    );
});
